(() => {
  let running = false;
  let scheduled = false;

  async function fetchCart() {
    const r = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return r.json();
  }

  async function setLineProperties(lineKey, quantity, properties) {
    console.log('[PackHero] Set line item ' + lineKey + ' properties ' + JSON.stringify(properties))

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        id: lineKey,
        quantity,
        properties
      })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`[PackHero] cart/change failed (${response.status}): ${text}`);
    }
  }

  function getLineMessageText(lineNode) {
    const parts = Array.from(lineNode.querySelectorAll("[data-packhero-line-message]"))
      .map((el) => {
        const type = el.getAttribute("data-packhero-line-message") || "default";
        const text = (el.textContent || "").replace(/\s+/g, " ").trim();
        if (!text) return null;
        return `<${type}>${text}</${type}>`;
      })
      .filter(Boolean);

    return parts.join("\n");
  }

  async function reconcile() {
    if (running) return;
    running = true;

    try {
      const nodes = Array.from(document.querySelectorAll("[data-packhero-line]"));
      if (!nodes.length) return;

      const desiredByKey = {};
      for (const n of nodes) {
        const key = n.getAttribute("data-line-key");
        if (!key) continue;

        desiredByKey[key] = {
          sellahead: n.getAttribute("data-sellahead") === "true" ? "true" : "false",
          message: getLineMessageText(n)
        };
      }

      const cart = await fetchCart();

      let didUpdate = false;

      for (const item of cart.items || []) {
        const desired = desiredByKey[item.key];
        if (!desired) continue;

        const currentSellAhead = item.properties?._sellahead ?? null;
        const currentMessage = item.properties?._ship_message ?? null;

        const needsSellAheadUpdate = currentSellAhead !== desired.sellahead;
        const needsMessageUpdate = currentMessage !== desired.message;

        if (!needsSellAheadUpdate && !needsMessageUpdate) continue;

        await setLineProperties(item.key, item.quantity, {
          ...(item.properties || {}),
          _sellahead: desired.sellahead,
          _ship_message: desired.message
        });
        didUpdate = true;
      }

      if (didUpdate) {
        if (window.themeVariables?.settings?.pageType === "cart") {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      }
    } catch (e) {
      console.error("[PackHero] Update failed", e);
    } finally {
      running = false;
    }
  }

  function scheduleReconcile() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      setTimeout(() => {
        scheduled = false;
        reconcile();
      }, 0);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleReconcile);
  } else {
    scheduleReconcile();
  }

  document.addEventListener("cart:change", scheduleReconcile);
  document.addEventListener("cart:refresh", scheduleReconcile);
  document.addEventListener("cart-drawer:refreshed", scheduleReconcile);
})();